// extracted by mini-css-extract-plugin
export default {"card":"list_card__-cc4e","text":"list_text__AMcVR","table":"list_table__KUm8f","button":"list_button__B3weJ"};